import React from "react";
import { Checkbox } from "primereact/checkbox";
import Task from "../Task";
import TasksContainer from "../TasksContainer";
import moment from "moment";
import { ACCOUNT_TYPE_ANIMATOR } from "../../consts/taskTypes";

const SchedulerRows = ({
   users,
   selectedProductKey,
   week,
   copyScheduleMode,
   scheduleCopyHelper,
   removeAnimatorConfirm,
   handleTaskSelection,
   redirectToTask,
   moveTask,
   removeTask,
   handleUserTasksSelection,
   history
}) => {
   return (users || []).map((user, userIndex) => {
      const tasksElements = week.map((day) => {
         if (!moment(day).isValid()) return false;
         const filteredTasks = (user.zadania || []).filter((task) => task.data === day);
         const sortedTasks = filteredTasks.sort((a, b) => {
            if (!(a.dane || b.dane)) return 0;

            const aTime = a.dane.godzina || a.dane.godzOd;
            const bTime = b.dane.godzina || b.dane.godzOd;
            if (!(aTime && bTime)) return 0;

            const [aHour, aMinute] = aTime.split(":");
            const [bHour, bMinute] = bTime.split(":");
            if (
               moment().set({ hour: aHour, minutes: aMinute }) >
               moment().set({ hour: bHour, minutes: bMinute })
            ) {
               return 1;
            } else {
               return -1;
            }
         });
         const tasks = sortedTasks.map((task) => {
            let taskName = task.krotkieInfo;
            let taskType = "task";
            if (task.typ === "WycieczkaFakultatywna") {
               taskType = "assigned-trip";
            }

            const selectionKey = `${user.id}_${task.id}`;
            const isSelected = scheduleCopyHelper.selectedTasks[selectionKey];

            return (
               <div className="flex" key={`task-${task.id}`}>
                  {copyScheduleMode && (
                     <Checkbox
                        checked={!!isSelected}
                        onChange={() => handleTaskSelection(task.id, user.id)}
                        className="mr-2"
                        inputId={`task-${task.id}`}
                     />
                  )}
                  <Task
                     onClick={(evt) => redirectToTask(evt, user, day, task.id)}
                     userId={user.id}
                     taskType={taskType}
                     taskName={taskName}
                     task={task}
                     moveTask={moveTask}
                     removeTask={removeTask}
                  />
               </div>
            );
         });
         return (
            <TasksContainer
               key={`cell-${userIndex}${day.replace(/-/g, "")}`}
               date={day}
               tasks={tasks}
               user={user}
               users={users}
               selectedProductKey={selectedProductKey}
               prevPath={history.location.pathname}
               copyScheduleMode={copyScheduleMode}
            />
         );
      });

      const hasAnyTasks = user.zadania && user.zadania.length > 0;

      const allUserTasksSelected =
         hasAnyTasks &&
         user.zadania.every((task) => {
            const selectionKey = `${user.id}_${task.id}`;
            return !!scheduleCopyHelper.selectedTasks[selectionKey];
         });

      const isUserSelected = allUserTasksSelected || !!scheduleCopyHelper.selectedUsers[user.id];

      return (
         <tr key={`row-${userIndex}`}>
            <td>
               <div className="flex">
                  {user.typKonta === ACCOUNT_TYPE_ANIMATOR && (
                     <div className="remove-button" onClick={() => removeAnimatorConfirm(user.id)}>
                        <span className="icon-close_icon" />
                     </div>
                  )}
                  {copyScheduleMode && (
                     <Checkbox
                        checked={isUserSelected}
                        onChange={() => handleUserTasksSelection(user.id)}
                        className="mr-2"
                        inputId={`user-${user.id}`}
                     />
                  )}
                  <label htmlFor={`user-${user.id}`}>
                     {user.imieNazwisko.split(" ").reverse().join(" ")}
                  </label>
               </div>
            </td>
            {tasksElements}
         </tr>
      );
   });
};

export default SchedulerRows;
